import { PTableHead, PTableHeadCell, PTableHeadRow } from "@porsche-design-system/components-react"
import { FormattedMessage } from "react-intl"
import { newsListMessages as messages } from "./newsList.messages"

interface NewsListTableHeadProps {
	hasActionColumn: boolean
}

export const NewsListTableHead = ({ hasActionColumn }: NewsListTableHeadProps) => {
	return (
		<PTableHead>
			<PTableHeadRow>
				<PTableHeadCell>
					<FormattedMessage {...messages.headerTitle} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...messages.headerStatus} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...messages.headerReviewStatus} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...messages.headerMarkets} />
				</PTableHeadCell>
				<PTableHeadCell>
					<FormattedMessage {...messages.headerUpdated} />
				</PTableHeadCell>
				{hasActionColumn && (
					<PTableHeadCell hideLabel>
						<FormattedMessage {...messages.deleteEntry} />
					</PTableHeadCell>
				)}
			</PTableHeadRow>
		</PTableHead>
	)
}
